var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CForm',{ref:"form",staticClass:"needs-validation"},[_c('CTextarea',{attrs:{"label":"Koli Kodları: ","placeholder":"Koli kodlarını altalta girin","horizontal":"","type":"text","rows":"9","autocomplete":"text"},model:{value:(_vm.data.parcelCodes),callback:function ($$v) {_vm.$set(_vm.data, "parcelCodes", $$v)},expression:"data.parcelCodes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }